import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_REST_API_VSMS

export const _get = async (queryParamFilters, queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParamFilters || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/address',
    params: params,
  })

  return response?.data
}

export const get = (queryParamFilters) => async (queryParam) =>
  await _get(queryParamFilters, queryParam)

export const show = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/address/${id}`,
  })

  return response?.data
}

export const getAddressTransit = async (queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/address',
    params: params,
  })

  return response?.data
}

export const _getAddressCategory = async (queryParamFilters, queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParamFilters || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/address-category',
    params: params,
  })

  return response?.data
}

export const getAddressCategory = (queryParamFilters) => async (queryParam) =>
  await _getAddressCategory(queryParamFilters, queryParam)
